import styled from 'styled-components'
import Title from 'components/common/display/Title'

export const StyledTitle = styled(Title)`
`

export const placeholder = '' // TODO: just to avoid default export
